import { Injectable, Injector } from '@angular/core';
import { NavigationEnd, Route, Router } from '@angular/router';
import { CanActiveAuthorizationModuleService } from 'projects/authentication/src/app/services/guard';
import { CacheService } from 'projects/common/src/app/services';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MACHINE_TYPE } from '../../../../../projects/common/src/app/enumerables/machine-type';
import { ViewControllerProviderService } from '../../app/services/view-controller-provider.service';
import { ZoneHandlerService } from '../../dashboard/services/zone-handler/zone-handler.service';
import { IApplication } from '../interfaces';
import { CanLoadParameterCheckRouteService } from './guard/can-load-parameter-check-route.base';
import { TargetAppService } from './parameter';
import { MachineCollectionService } from './parameter/machine-collection/machine-collection.service';
import { MachineContextService } from './parameter/machine-context/machine-context.service';
import { GoogleAnalyticsService } from './google/google-analytics.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private injector: Injector,
    private cacheService: CacheService,
    private app: TargetAppService,
    private viewProvider: ViewControllerProviderService,
    private machineContext: MachineContextService,
    private zoneHandlerSvc: ZoneHandlerService,
    private machineCollectionService: MachineCollectionService,
    private _googleService: GoogleAnalyticsService,
  ) {}

  public get router(): Router {
    return this.injector.get(Router);
  }

  public init() {
    this.router.events
      .pipe(
        map((event) => {
          if (event instanceof NavigationEnd) {
            return event;
          }
        }),
      )
      .subscribe((e: NavigationEnd) => this.saveNavigation(e));

    // Suscripcion a nueva aplicación
    // Agrega las nuevas rutas como rutas hijas de la ruta ``app``
    // Asi existen a la hora de navegación
    this.app.getObservable().subscribe((app: IApplication) => {
      const menu = app.childs;
      const appPath = this.router.config.find((route: any) => route.path === environment.homePath);
      appPath.children = [];
      this.routeBuilder(menu, appPath.children);
    });
  }

  public routeBuilder(options: any[], sourceChildren: any[]) {
    for (const option of options) {
      const route: Route = {
        path: option.url,
        canLoad: [CanLoadParameterCheckRouteService],
        canActivate: [CanActiveAuthorizationModuleService],
        component: this.viewProvider.provide(this.app.getId(), option.name),
      };
      if (option.childs.length) {
        route.children = [];
        this.routeBuilder(option.childs, route.children);
      }
      sourceChildren.push(route);
    }
  }

  public currentUrl(): string {
    const current = this.cacheService.session('currNavigation');
    return current;
  }

  public prevUrl(): string {
    const prev = this.cacheService.session('prevNavigation');
    return prev;
  }

  private saveNavigation(e: NavigationEnd): void {
    if (!this.cacheService.session('machineCollection')) {
      const machineCollection = this.machineCollectionService.get();
      this.cacheService.saveSession('machineCollection', machineCollection);
    }

    if (e) {
      const splitted = e.url.split('/');
      const isDashboard = splitted.find((url) => url.toLowerCase() === 'dsh');
      const machine = splitted.find((url) => !!MACHINE_TYPE[url.toLowerCase()]);

      this.zoneHandlerSvc.verifySelectedZone(e.url);
      this._googleService.sendPageView(e.urlAfterRedirects);

      // TODO modificar
      // se verifica que sea path para un dashboard
      if (isDashboard && !!machine) {
        this.machineContext.setMachine(machine);
        if (!this.cacheService.session('machine-context')) {
          const machineContext = this.machineContext.setMachine(machine);
          this.cacheService.saveSession('machine-context', machineContext);
        }
      }
      const current = this.currentUrl();
      this.cacheService.saveSession('prevNavigation', current);
      this.cacheService.saveSession('currNavigation', e.url);
    }
  }

  private cleanPath(value: string) {
    if (typeof value === 'string') {
      const splitted = value.split('/');
      if (splitted.length) {
        return splitted[1];
      }
    }
    return value;
  }
}
